import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/components/shared/PageFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/components/shared/PageHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/frontend/node_modules/next/dist/client/app-dir/link.js");
